<template>
  <div class="swiper-item">
     <van-swipe  :autoplay="3000" class="swipe" :show-indicators="false" v-if="announceList.length != 0">
      <van-swipe-item v-for="list in announceList" :key="list.bannerId" >
        <!--直接跳转到网页-->
        <a :href="list.resource" v-show="list.resourceType == 'PR_WEB'">
          <div class="outter-banner">
            <img :src="list.bannerPictureUrl" alt>
          </div>
        </a>
        <!--直接跳转到小程序-->
      <div class="outter-banner"  v-show="list.resourceType == 'PR_XCX_EXTERNAL_JUMP'" >
          <img :src="list.bannerPictureUrl" alt>
      </div>
       <wx-open-launch-weapp
        id="launch-btn"
        :username="list.wechatId"
        :path="list.wechatPath"
        class="outter-banner"
        v-show="!isShowBtn && list.resourceType == 'PR_XCX_EXTERNAL_JUMP'"
      >
        <script type="text/wxtag-template" >
          <style>
          .banner {
            height: 110px!important;
            border-radius: 8px;
            width: 345px!important;
            z-index: 100!important;
          }
          </style>
          <div class="banner">
          </div>
        </script>
      </wx-open-launch-weapp>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
    import {
        getAnnounceBanner
    } from "@/api/eating";
    import {
        Swipe,
        SwipeItem
    } from "vant";

    export default {
        data() {
            return {
                announceList: [],
                isShowBtn: false,
                wechatId: "gh_492f77190674",
                wechatPath: "packages/goods/detail/index?alias=1y2wwrk2jz7m9&shopAutoEnter=1",
            };
        },
        name: "swiper-item",
        components: {
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
        },
        props: {
            params: {
                type: Object,
                default: function() {
                    return {
                        phaseInquire: 0,
                        bannerQuantity: 100,
                        businessKey: 'APP_WHETHER_CAN_EAT_INDEX'
                    }
                }
            }
        },

        computed: {

        },
        created() {
            this.fetchAnnounceBanner()
        },
        methods: {
            /**
             * 获取公告banner
             */
            async fetchAnnounceBanner() {
                let params = this.params
                const res = await getAnnounceBanner(params);
                if (res.code == 0) {
                    for (let i = 0; i < res.data.length; i++) {
                      if(res.data[i].resourceType == 'PR_XCX_EXTERNAL_JUMP') {
                        let resource = JSON.parse(res.data[i].resource)
                        res.data[i].wechatId = resource.appId
                        res.data[i].wechatPath = resource.path
                      }
                    }
                    this.announceList = res.data;
            }
        }
        }
    };
</script>
<style lang="less" scoped>
// .swiper-item {
//   // padding: 0;
//   // width: 100vw;
//   // box-sizing: border-box;
// }
    .swipe {
        height: 110px;
        margin: 15px;
        border-radius: 8px;
        width: calc(100% - 30px);
        .outter-banner {
            align-items: center;
            height: 100%;
            width: 100%;
            position: absolute;
            top:0;
            left: 0;
            img {
                height: 100%;
                width: 100%;
            }
        }
    }
</style>